import { User } from "lucide-react"

interface LoginButtonProps {
  onClick: () => void
}

/** LoginButton — 未登录时的导航栏登录按钮 */
export function LoginButton({ onClick }: LoginButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-8 items-center gap-1.5 px-3 rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
      aria-label="登录"
    >
      <User className="h-4 w-4" />
      <span className="text-xs">登录</span>
    </button>
  )
}
